import React from 'react';
import { InstagramIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-charcoal-950 text-offwhite-200 py-12 border-t border-charcoal-900" data-id="element-194" data-mp="3gfsn6dua2wni">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-195" data-mp="32o48c2sn9u2u">
        <div className="text-center md:text-left" data-id="element-196" data-mp="36oo5359b2vog">
          <a href="#" className="text-2xl font-bold text-offwhite-50 tracking-tight block mb-2" data-id="element-197" data-mp="36n3dnoiafsut">
            McLean <span className="text-amber-500" data-id="element-198" data-mp="38z8yrj06z2w">PT</span>
          </a>
          <p className="text-sm text-charcoal-500" data-id="element-199" data-mp="3lecaahklyehg">
            Physical Therapy & Performance Coaching · Camarillo, CA
          </p>
          <p className="text-sm text-offwhite-200 mt-3" data-id="element-200" data-mp="3qcniyoz62iy3">
            <span className="text-amber-500 font-medium" data-id="element-201" data-mp="3qf9sgu5mb8iy">
              In-person appointments:
            </span>{' '}
            House of Gains Gym, Camarillo, CA · By appointment only
          </p>
        </div>

        <div className="flex items-center space-x-6" data-id="element-202" data-mp="3l9adtjp9964y">
          <a href="https://www.instagram.com/dylanmclean.dpt/" target="_blank" rel="noopener noreferrer" className="text-charcoal-500 hover:text-amber-500 transition-colors" data-id="element-203" data-mp="3la288r748xtn">
            <InstagramIcon size={24} data-id="element-204" data-mp="3q8mypywkg34w" />
            <span className="sr-only" data-id="element-205" data-mp="3q7lmvs7q7cm4">Instagram</span>
          </a>
          <a href="mailto:info@mcleanphysicaltherapy.com" className="text-charcoal-500 hover:text-amber-500 transition-colors" data-id="element-206" data-mp="82qsbsqetttq">
            <MailIcon size={24} data-id="element-207" data-mp="33nmw76ipll8" />
            <span className="sr-only" data-id="element-208" data-mp="hsk3ismn46xg">Email</span>
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-8 pt-8 border-t border-charcoal-900 text-center md:text-left flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-charcoal-600" data-id="element-209" data-mp="huo8ldw9zbzb">
        <p data-id="element-210" data-mp="mrwm316haru8">
          &copy; {new Date().getFullYear()} McLean Physical Therapy. All rights
          reserved.
        </p>
        <div className="flex space-x-4" data-id="element-211" data-mp="tvw6kdlnj9ee">
          <a href="#" className="hover:text-offwhite-200 transition-colors" data-id="element-212" data-mp="twxtpgfxzmch">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-offwhite-200 transition-colors" data-id="element-213" data-mp="yruzmehxdfl5">
            Terms of Service
          </a>
        </div>
      </div>
    </footer>;
}